var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8997,
    cy: 18.7,
    r: 18.7,
    fill: "#EDEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6243 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.738 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1812 30.6052C26.6204 30.6052 30.8051 26.4206 30.8051 18.9813C30.8051 11.542 26.6204 7.35742 19.1812 7.35742C11.7419 7.35742 7.55725 11.542 7.55725 18.9813C7.55725 26.4206 11.7419 30.6052 19.1812 30.6052Z",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5916 21.5632C14.423 23.7025 16.3491 24.8667 19.1807 24.8667C22.0122 24.8667 23.9383 23.7025 24.7698 21.5632",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile2);
export default __webpack_public_path__ + "static/media/smile-2.efcc37790a4c1deaa2080321e502c86a.svg";
export { ForwardRef as ReactComponent };